import React from 'react';
import {
  DragDropContext,
  Draggable,
  Droppable,
  OnBeforeCaptureResponder,
  OnBeforeDragStartResponder,
  OnDragEndResponder,
  OnDragStartResponder,
  OnDragUpdateResponder,
  DroppableId,
  DroppableProvided,
  DroppableStateSnapshot,
  DraggableProvided,
  DraggableStateSnapshot,
  DropResult,
  ResponderProvided,
} from 'react-beautiful-dnd';

type Props = {
  droppableId: DroppableId;
  list: Array<any>;
  childGenerator: (
    item: Item,
    provided: DraggableProvided,
    index: number,
    additionalProps?: any,
  ) => JSX.Element | React.ReactNode;
  onChange: (newIndex: number, oldIndex: number) => void;
  onBeforeCapture?: OnBeforeCaptureResponder;
  onBeforeDragStart?: OnBeforeDragStartResponder;
  onDragStart?: OnDragStartResponder;
  onDragUpdate?: OnDragUpdateResponder;
  onDragEnd?: OnDragEndResponder;
  disableAllDrags?: boolean;
  additionalPropsToItem?: any;
};

type Item = Record<string, unknown> & {
  draggableId: string;
  title?: JSX.Element;
  content?: JSX.Element;
};

const DragItem = (props) => {
  const { childGenerator, item, index, provided, additionalProps } = props;
  const _item = () => {
    return childGenerator(item, provided, index, additionalProps);
  };
  return <React.Fragment>{_item()}</React.Fragment>;
};

function DragNDrop({
  droppableId,
  list,
  childGenerator,
  onChange,
  onBeforeCapture,
  onBeforeDragStart,
  onDragStart,
  onDragUpdate,
  onDragEnd,
  disableAllDrags,
  additionalPropsToItem,
}: Props) {
  const handleDragEnd = (result: DropResult, provided: ResponderProvided) => {
    // console.log('result', result);
    const oldIndex = result?.source?.index;
    const newIndex = result?.destination?.index;
    if (/^[0-9]+$/.test(`${oldIndex}`) && /^[0-9]+$/.test(`${newIndex}`))
      onChange(newIndex, oldIndex);
    if (onDragEnd) onDragEnd(result, provided);
  };

  return (
    <DragDropContext
      onBeforeCapture={onBeforeCapture}
      onBeforeDragStart={onBeforeDragStart}
      onDragEnd={handleDragEnd}
      onDragStart={onDragStart}
      onDragUpdate={onDragUpdate}>
      <Droppable droppableId={droppableId}>
        {(provided: DroppableProvided, snapshot: DroppableStateSnapshot) => {
          return (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {list.map((item, index: number) => {
                return (
                  <Draggable
                    isDragDisabled={!!(disableAllDrags || item.disabled)}
                    draggableId={item.draggableId || item.fieldKey}
                    index={index}
                    key={item.draggableId || item.fieldKey}>
                    {(
                      provided: DraggableProvided,
                      snapshot: DraggableStateSnapshot,
                    ) => {
                      return (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}>
                          <DragItem
                            childGenerator={childGenerator}
                            item={item}
                            provided={provided}
                            index={index}
                            additionalProps={additionalPropsToItem}
                          />
                          {/* {childGenerator &&
                            childGenerator(item, provided, index)} */}
                        </div>
                      );
                    }}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          );
        }}
      </Droppable>
    </DragDropContext>
  );
}

export default DragNDrop;
